<style lang="scss">
  #app {}
</style>

<template>
  <div id="app">
    <c-loading v-if="loading && !loaded"/>
    <router-view v-else/>
  </div>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  name: 'app',
  computed: {
    loading: get('loading'),
    loaded: get('loaded')
  }
};
</script>
